import argFlag from './assets/images/arg.jpg';
import chiFlag from './assets/images/chile.jpg';
import colFlag from './assets/images/col.jpg';
import mexFlag from './assets/images/mex.jpg';
import peFlag from './assets/images/pe.jpg';

export interface ContactDialogDataProps {
  phones: {
    id: number;
    iso: string;
    number: string;
    flag: string;
  }[];
}

const data = {
  phones: [
    {
      id: 4,
      iso: 'MÉX',
      number: '+52 55 4172 0323',
      flag: mexFlag,
    },
    {
      id: 3,
      iso: 'COL',
      number: '+57 601 5088808',
      flag: colFlag,
    },
    {
      id: 1,
      iso: 'PE',
      number: '+51 1 7018946',
      flag: peFlag,
    },
    {
      id: 2,
      iso: 'AR',
      number: '+54 11 5984-2515',
      flag: argFlag,
    },
    {
      id: 6,
      iso: 'CH',
      number: '+56 44 204 5036',
      flag: chiFlag,
    },
  ],
};
export default data;
